<template>
    <article class="selector">
        <div @click="toggle" class="form__input selector__input">
            <span>{{ label }}</span>
            <icon type="chevron-bottom" color="bluegray" size="12" />
        </div>
        <nav v-if="isOpen" class="selector__menu">
            <div v-for="option in options" :key="option.value" @click.stop="select(option.value)" class="selector__item">{{ option.label }}</div>
        </nav>
        <select v-model="value" :name="name" :id="name">
            <slot />
        </select>
    </article>
</template>

<script>
import Icon from '../Global/Icon'
import Toggleable from '../../mixins/toggle'

export default {
    name: 'Selector',

    mixins: [Toggleable],

    props: {
        value: {
            default: null
        },

        name: {
            required: true,
            type: String
        }
    },

    methods: {
        select (option) {
            this.$emit('input', option)
            this.close()
        }
    },

    computed: {
        options () {
            return this.$slots.default.filter(option => option.tag === 'option').map(option => {
                return {
                    value: option.elm.value,
                    label: option.elm.text
                }
            })
        },

        label () {
            if (this.value) {
                return this.options.find(option => option.value === this.value).label
            }

            return 'Choose an option'
        }
    },

    components: {
        Icon
    }
}
</script>
